module.exports = __webpack_public_path__ + "static/media/语音识别（英语，单词）.4ab197d8.png";